/* import __COLOCATED_TEMPLATE__ from './stripe-element-loading-display.hbs'; */
import { dismissSticky, error } from 'client-portal/utils/banners';
import { service } from '@ember/service';
import { task, timeout, waitForProperty } from 'ember-concurrency';
import Component from '@glimmer/component';
import ENV from 'client-portal/config/environment';

export default class SharedStripeElementLoadingDisplay extends Component {
  @service intl;

  timeToError = ENV.stripeElementLoadingErrorDelay;

  constructor() {
    super(...arguments);
    this.handleError.perform();
  }

  handleError = task(async () => {
    let didShow = false;
    try {
      await timeout(this.timeToError);

      if (this.args.isElementLoaded) {
        return;
      }

      didShow = true;
      this.showErrorBanner();

      await waitForProperty(this.args, 'isElementLoaded');
    } finally {
      if (didShow) dismissSticky();
    }
  });

  showErrorBanner() {
    let content = document.createElement('p');
    content.innerText = this.intl.t('shared.errors.loadingError');
    error({
      title: this.intl.t('shared.errors.paymentFormError'),
      content,
    });
  }
}
